<template>
	<router-view></router-view>
</template>

<script>
export default {
	name: 'main-accounting',
};
</script>




// WEBPACK FOOTER //
// src/components/accounting/main-accounting.vue